import { PlatformIcon } from '../../utils/platformIcons';
import { capitalizePlatformName } from '../../utils/platformNames';

const PlatformSelectionModal = ({
    show,
    onClose,
    selectedPlatforms = [],
    platformData = [],
    locationData = [],
    onPlatformSelect
}) => {
    if (!show) return null;

    // Get platform URLs from location data
    const getPlatformUrl = (platformId) => {
        for (const location of locationData) {
            const platform = location.platforms?.find(p => p.name === platformId);
            if (platform && platform.profileUrl) {
                return platform.profileUrl;
            }
        }
        return null;
    };

    const handlePlatformClick = (platformId) => {
        const url = getPlatformUrl(platformId);
        if (url) {
            window.open(url, '_blank');
        }
        if (onPlatformSelect) {
            onPlatformSelect(platformId, url);
        }
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
                <div className="p-6">
                    <div className="flex items-center justify-between mb-6">
                        <div>
                            <h2 className="text-xl font-bold text-gray-900">Choose the Platform</h2>
                            <p className="text-sm text-gray-600 mt-1">Choose the preferred platform to share your review</p>
                        </div>
                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-gray-600 transition-colors"
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div className="space-y-3">
                        {selectedPlatforms.map((platformId) => {
                            const platform = platformData.find(p => p.id === platformId) || { id: platformId, name: platformId };
                            const url = getPlatformUrl(platformId);

                            return (
                                <button
                                    key={platformId}
                                    onClick={() => handlePlatformClick(platformId)}
                                    className="w-full flex items-center p-4 rounded-lg border border-gray-200 hover:border-blue-500 hover:bg-blue-50 transition-all duration-200 group"
                                >
                                    <div className="w-12 h-12 mr-4 flex items-center justify-center bg-gray-100 rounded-lg group-hover:bg-blue-100">
                                        <PlatformIcon
                                            platform={platformId}
                                            className="w-8 h-8"
                                            alt={`${platform.name} icon`}
                                        />
                                    </div>
                                    <div className="flex-1 text-left">
                                        <div className="font-medium text-gray-900 group-hover:text-blue-900">
                                            {capitalizePlatformName(platform.name || platformId)}
                                        </div>
                                        {url ? (
                                            <div className="text-sm text-gray-500 group-hover:text-blue-600">
                                                Click to write review
                                            </div>
                                        ) : (
                                            <div className="text-sm text-orange-600">
                                                No URL configured
                                            </div>
                                        )}
                                    </div>
                                    <div className="ml-4">
                                        <svg className="w-5 h-5 text-gray-400 group-hover:text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                        </svg>
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlatformSelectionModal; 